import BasicValidation from 'components/components/common/BasicValidation';
import TransHelper from 'components/common/translations/TransHelper';

export default class FirstStepValidation extends BasicValidation {
  constructor(props) {
    super();
    this.props = props;
  }

  isDateValid() {
    return this.props.startDate.value !== null;
  }

  isAirportFromValid() {
    return this.props.airportFrom.label && this.props.airportFrom.label !== '';
  }

  isAirportToValid() {
    return this.props.airportTo.label && this.props.airportTo.label !== '';
  }

  isNumberOfPassengersValid() {
    return this.props.adultsNumber > 0
      || this.props.childrenNumber > 0
      || this.props.seniorsNumber > 0
      || this.props.teenagersNumber > 0
      || this.props.studentsNumber > 0;
  }

  isValidForm() {
    return this.isDateValid() &&
      this.isNumberOfPassengersValid() &&
      this.isAirportFromValid() &&
      this.isAirportToValid();
  }

  trans(key) {
    return TransHelper.translate(this.props.locale, key);
  }

  getFieldsErrors() {
    var hash = {};

    if (!this.isDateValid()) {
      hash['date'] = this.trans('content.bookingStep1.errors.date');
    }
    if (!this.isNumberOfPassengersValid()) {
      hash['passengers'] = this.trans('content.bookingStep1.errors.passengers');
    }
    if (!this.isAirportFromValid()) {
      hash['airportFrom'] = this.trans('content.bookingStep1.errors.busStop');
    }
    if (!this.isAirportToValid()) {
      hash['airportTo'] = this.trans('content.bookingStep1.errors.busStop');
    }
    return hash;
  }

}
